// import { useState } from "react";
// import Button from "react-bootstrap/Button";
// import Offcanvas from "react-bootstrap/Offcanvas";
// import "./OffcanvasCon.css";
// import { Table } from "react-bootstrap";
// const OffcanvasCon = (props) => {



//   return (
//     <>
//       <Offcanvas
//         show={props.show}
//         onHide={props.handleClose}
//         placement={"end"}
//       // {...props}
//       >
//         <Offcanvas.Header closeButton>
//           <Offcanvas.Title></Offcanvas.Title>
//         </Offcanvas.Header>
//         <Offcanvas.Body>
//           <section className="Offcanvasmiancon">
//             <div className="container-fluid">
//               <div className="card">
//                 <div className="card-body">
//                   <div className="offhead">
//                     <h3>Import Report:</h3>
//                   </div>

//                   <div className="table-responsive mainTableOff">
//                     <Table striped bordered hover>
//                       <thead>
//                         <tr>
//                           <th>Added Records</th>
//                           <td>{props?.show?.Added_Count}</td>
//                           <th>Not Added Records</th>
//                           <td>{props.show.Error_Count || 0}</td>
//                           <th>Total Records</th>
//                           <td>
//                             {(props?.show?.Added_Count || 0) + (props?.show?.Error_Count || 0)}
//                           </td>
//                         </tr>
//                         <tr></tr>
//                       </thead>
//                     </Table>
//                   </div>
//                   {/* <div className="storeAddedhead">
//                     <p>Added List:</p>
//                   </div>

//                   <div className="table-responsive mainTableOff">
//                     <Table striped bordered hover>
//                       <thead>
//                         <tr>
//                           <th>Sr.No</th>
//                           {props?.show?.Added?.map((head) => (
//                             <>
//                               <th>{head}</th>
//                               <th>{head?.Name}</th>
//                             </>
//                           ))}
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {props?.show?.Added?.map((added, index) => (
//                           <tr key={index}>
//                             <td>{++index}</td>
//                             {props?.show?.Added?.map((head) => (
//                               <td>{added[head]}</td>
//                             ))}
//                           </tr>
//                         ))}
//                       </tbody>
//                     </Table>
//                   </div> */}
//                   {/* ================= ADDED LIST ================= */}
//                   <div className="storeAddedhead">
//                     <p>Added List:</p>
//                   </div>

//                   <div className="table-responsive mainTableOff">
//                     <Table striped bordered hover>
//                       <thead>
//                         <tr>
//                           <th>Sr.No</th>
//                           <th>Product Name</th>
//                         </tr>
//                       </thead>

//                       <tbody>
//                         {props?.show?.Added?.length > 0 ? (
//                           props.show.Added.map((added, index) => (
//                             // <tr key={added?.Product_ID || index}>
//                             <tr key={index}>
//                               <td>{index + 1}</td>
//                               <td>{added?.Name || "-"}</td>
//                             </tr>
//                           ))
//                         ) : (
//                           <tr>
//                             <td colSpan={2} className="text-center">
//                               No records found
//                             </td>
//                           </tr>
//                         )}
//                       </tbody>
//                     </Table>
//                   </div>

//                   {/* ================= NOT ADDED LIST ================= */}
//                   <div className="storeAddedhead">
//                     <p>Not Added List:</p>
//                   </div>

//                   <div className="table-responsive mainTableOff">
//                     <Table striped bordered hover>
//                       <thead>
//                         <tr>
//                           <th>Sr.No</th>
//                           <th>Row</th>
//                           <th>Reason</th>
//                         </tr>
//                       </thead>

//                       <tbody>
//                         {props?.show?.Errors?.length > 0 ? (
//                           props.show.Errors.map((error, index) => (
//                             <tr key={index}>
//                               <td>{index + 1}</td>
//                               <td>{error?.Row || "-"}</td>
//                               <td>{error?.Reason || "-"}</td>
//                             </tr>
//                           ))
//                         ) : (
//                           <tr>
//                             <td colSpan={3} className="text-center">
//                               No records found
//                             </td>
//                           </tr>
//                         )}
//                       </tbody>
//                     </Table>
//                   </div>


//                 </div>
//               </div>
//             </div>
//           </section>
//         </Offcanvas.Body>
//       </Offcanvas>
//     </>
//   );
// };

// export default OffcanvasCon;

import Offcanvas from "react-bootstrap/Offcanvas";
import "./OffcanvasCon.css";
import { Table } from "react-bootstrap";

const OffcanvasCon = (props) => {
  const data = props?.show; // the report data object
  const addedList = data?.Added || [];
  const errorList = data?.Exists || [];
  const addedCount = data?.Added_Count || 0;
  const errorCount = data?.Exists_Count || 0;

  return (
    <Offcanvas show={props.show} onHide={props.handleClose} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title></Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <section className="Offcanvasmiancon">
          <div className="container-fluid">
            <div className="card">
              <div className="card-body">
                <div className="offhead">
                  <h3>Import Report:</h3>
                </div>

                {/* ================= SUMMARY TABLE ================= */}
                <div className="table-responsive mainTableOff">
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>Added Records</th>
                        <th>Not Added Records</th>
                        <th>Total Records</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{addedCount}</td>
                        <td>{errorCount}</td>
                        <td>{addedCount + errorCount}</td>
                      </tr>
                    </tbody>
                  </Table>
                </div>

                {/* ================= ADDED LIST ================= */}
                <div className="storeAddedhead">
                  <p>Added List:</p>
                </div>

                <div className="table-responsive mainTableOff">
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>Sr.No</th>
                        <th>Product Name</th>
                      </tr>
                    </thead>

                    <tbody>
                      {addedList.length > 0 ? (
                        addedList.map((added, index) => (
                          <tr key={added?.Product_ID ?? index}>
                            <td>{index + 1}</td>
                            <td>{added?.Name || "-"}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={2} className="text-center">
                            No records found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>

                {/* ================= NOT ADDED LIST ================= */}
                <div className="storeAddedhead">
                  <p>Not Added List:</p>
                </div>

                <div className="table-responsive mainTableOff">
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>Sr.No</th>
                        <th>Row</th>
                        <th>Name</th>
                        <th>Reason</th>
                      </tr>
                    </thead>

                    <tbody>
                      {errorList.length > 0 ? (
                        errorList.map((error, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{error?.Row || "-"}</td>
                            <td>{error?.Name || "-"}</td>
                            <td>{error?.Reason || "-"}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={3} className="text-center">
                            No records found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default OffcanvasCon;

